// @ts-strict-ignore
import { Controller } from '@hotwired/stimulus'
import { debounce } from '../utils'

export default class extends Controller<HTMLFormElement> {
  static targets = [
    'leftIconButton',
    'rightIconButton',
    'subContainerContent',
    'stickyNavHeader',
    'stickyNavWrapper',
    'stickyNavTitle',
  ]

  sections = document?.querySelector('#app')?.querySelectorAll('div[id],section[id]')

  declare readonly stickyNavTitleTarget: HTMLElement
  declare readonly stickyNavWrapperTarget: HTMLElement
  declare readonly stickyNavHeaderTarget: HTMLElement
  declare readonly subContainerContentTarget: HTMLElement
  declare readonly leftIconButtonTarget: HTMLElement
  declare readonly rightIconButtonTarget: HTMLElement

  constructor(props: any) {
    super(props)
    this.navHighlighter = this.navHighlighter.bind(this)
    this.handleScroll = this.handleScroll.bind(this)
  }

  scrollTabs(event: any, distance: number) {
    const arrLeft: any = this.leftIconButtonTarget.getElementsByTagName('use')
    const arrRight: any = this.rightIconButtonTarget.getElementsByTagName('use')
    const brand = window.__BRAND__
    if (distance > 0) {
      // Add and remove class for disblaed
      this.leftIconButtonTarget.classList.remove('disabledIcon')
      this.rightIconButtonTarget.classList.add('disabledIcon')

      arrLeft[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/arrow-left.svg?v=12#arrow-left`,
      )
      arrRight[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/ButtonRightDisabled.svg?v=12#ButtonRightDisabled`,
      )
    } else {
      // Add and remove class for disblaed
      this.leftIconButtonTarget.classList.add('disabledIcon')
      this.rightIconButtonTarget.classList.remove('disabledIcon')

      arrLeft[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/ButtonLeftDisabled.svg?v=12#ButtonLeftDisabled`,
      )
      arrRight[0].setAttribute(
        'href',
        `/fs-core-assets/icons/${brand}/arrow-right.svg?v=12#arrow-right`,
      )
    }

    this.subContainerContentTarget.scrollBy({
      left: this.subContainerContentTarget.offsetWidth * distance,
      behavior: 'smooth',
    })
    event.preventDefault()
  }

  leftArrowIconClick(event) {
    this.scrollTabs(event, -1)
  }

  rightArrowIconClick(event) {
    this.scrollTabs(event, 1)
  }

  getOffsetTop = (element) => {
    const rect = element.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    return rect.top + scrollTop
  }

  handleScroll() {
    const scrollY = window.pageYOffset
    // Condition for stikcy NAV issue on safari browser
    if (document.getElementsByClassName('sticky')[0]) {
      document.getElementsByClassName('active')[0]?.scrollIntoView()
    }

    this.sections.forEach((current: any) => {
      const sectionHeight = current?.offsetHeight + 96
      const sectionTop = this.getOffsetTop(current) - 200
      const sectionId = current?.getAttribute('id')
      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        document
          .querySelector('.navigation a[data-ele*=data-' + sectionId + ']')
          ?.classList.add('active')
      } else {
        document
          .querySelector('.navigation a[data-ele*=data-' + sectionId + ']')
          ?.classList.remove('active')
      }
    })
  }

  navHighlighter() {
    const scrollY = this.stickyNavWrapperTarget?.getBoundingClientRect().y

    if (scrollY < 0) {
      this.stickyNavHeaderTarget?.classList.add('sticky')
      this.stickyNavTitleTarget?.classList.add('hide-title')

      this.leftIconButtonTarget.style.visibility = 'hidden'
      this.rightIconButtonTarget.style.visibility = 'hidden'
    } else {
      this.stickyNavHeaderTarget?.classList.remove('sticky')
      this.stickyNavTitleTarget?.classList.remove('hide-title')

      this.leftIconButtonTarget.style.visibility = 'visible'
      this.rightIconButtonTarget.style.visibility = 'visible'
    }

    debounce(this.handleScroll, 750)()
  }

  connect() {
    this.sections.forEach((ele) => ele.classList.add('scroll-margin'))

    if (this.stickyNavHeaderTarget) {
      window.addEventListener('scroll', this.navHighlighter)
    } else {
      window.removeEventListener('scroll', this.navHighlighter)
    }
  }
}
